export class StringResponse {

  constructor(
    public value?: string) {
  }
}


